import * as React from "react";

const checkNew: React.FC = () => {
    return ( 
        <svg width="74" height="74" xmlns="http://www.w3.org/2000/svg">
            <path d="M37 .25C16.704.25.25 16.704.25 37S16.704 73.75 37 73.75 73.75 57.296 73.75 37A36.75 36.75 0 0 0 37 .25Zm0 68.25C19.603 68.5 5.5 54.397 5.5 37S19.603 5.5 37 5.5 68.5 19.603 68.5 37 54.397 68.5 37 68.5Zm-5.25-17.063-13.125-13.02 4.174-4.12 8.951 8.872 19.451-19.294 4.174 4.148L31.75 51.438Z" fill="#FFF" fill-rule="evenodd"/></svg>
    );
};


export default React.memo(checkNew);
